
import React, { Component } from 'react';

export class IBZA extends Component {

    render() {
        return (
            <div>
                <h1 align='center'>IBZ App Department</h1>
                   <br />
                <p>This was a legacy division which is now dissolved, it developed native desktop apps in Electron.JS and Swift, it also look at ionic solutions, more recently it also did some work on dotnet MAUI but it was never published</p>
                <h2 align="center">Links</h2>
                <ul>
                    <li><b>Main Website </b><a href='https://ibz-apps.vercel.app'>https://ibz-apps.vercel.app</a></li>
                    <li><b>Swift IBZ app </b><a href='https://ibz-apps.vercel.app/apple/macOS/ibz'>https://ibz-apps.vercel.app/apple/macOS/ibz</a></li>
                    <li><b>nextron IBZ app </b><a href='https://ibz-apps.vercel.app/apple/macOS/ibznextron'>https://ibz-apps.vercel.app/apple/macOS/ibznextron</a></li>
                   
                </ul>
            </div>
        );
    }
}

